const responsify = require('./responsify');
const platform = require('platform');

const config = require('./config.yaml');
const Tools = require('./classes/Tools.js');
const SliderController = require('./classes/SliderController');
const DEBUG = Boolean(!templateVars.production);

function initMainpageSliderController() {
	Tools.disableTab($('#mainpage-slider-wrapper *'));

	let sliderController = false;
	let $mainpageSlider = $('#mainpage-slider');

	if (!$mainpageSlider.length) {
		return false;
	} else {
		/**
		 * Контроллер для управления слайдером
		 * @type {CSlideLineController}
		 */
		sliderController = new SliderController();
		// sliderController.switchItemByID(0, true);
	}

	let currentSlideIndex = 0;
	let $mainpageSliderWrapper = $('#mainpage-slider-wrapper');
	const sliderChangeSpeed = config.sliderParams['sliderAnimationSpeed'] || 1000;

	$mainpageSlider.swiper({
		speed: sliderChangeSpeed,
		mousewheelControl: true,
		direction: 'vertical',
		keyboardControl: true,
		simulateTouch: false,
		onSlideChangeStart: function (swiper) {
			sliderController.lockSlider();
			swiper.disableMousewheelControl();
			swiper.disableKeyboardControl();
			sliderController.lockSlider();

			let index = swiper.activeIndex;
			let $slide = $(sliderController.getSlide(index));
			let slideRealIndex = $slide.attr('data-slide-id');


			let slideInteractivePackID = $slide.attr('data-interactive-id');

			//переключение хеша в адресной строке
			let slideHash = sliderController.getFullHashBySlideID(slideRealIndex);
			if (slideHash) {
				Tools.setPageHash(slideHash);
			}

			if (slideInteractivePackID) {
				sliderController.resetInteractivePack(slideInteractivePackID);
			}

			//прокручиваем progress-bar на первый элемент нового слайда
			sliderController.progressBarController.fillSection(
				sliderController.getMainCurrentSlideID(),
				1
			);

			// //Страховка, т.к. иногда события кончания смены сайда не отрабатывает
			// //Также событие не работает в некоторых неожиданных браузерах
			// setTimeout(() => {
			// 	swiper.fireCallback('SlideChangeEnd', swiper);
			// }, sliderChangeSpeed);

		},
		onSlideChangeEnd: function (swiper) {
			sliderController.unlockSlider();
			swiper.enableMousewheelControl();
			swiper.enableKeyboardControl();

			let index = swiper.realIndex;
			let $slide = $(sliderController.getSliderItemByID(index));
		},
		onInit: function (swiper) {
			sliderController.mainSliderInstance = swiper;

			sliderController.initInteractivePacks()
				.then(() => {
					sliderController.initPlayStopControllerEvent();
					sliderController.buildProgressBar();

					//прокручиваем progress-bar на первый элемент нового слайда
					sliderController.progressBarController.fillSection(
						sliderController.getMainCurrentSlideID(),
						1
					);

					let addressHash = Tools.getPageHash();
					//Проверка, нужно ли переключиться к слайду по хешу страницы
					if (addressHash) {
						//разделяем хэш по разделителю
						let arHashSlideID = Tools.divideHashByDelimiter();
						sliderController.goToSlideByHash(arHashSlideID);
					} else {

						let $slide = $(sliderController.getSliderItemByID(swiper.activeIndex));
						let slideRealIndex = $slide.attr('data-slide-id');

						// запуск пака анимации для слайда
						sliderController.resetInteractivePack(sliderController.getMainCurrentSlideID());

						//переключение хеша в адресной строке
						let slideHash = sliderController.getFullHashBySlideID(slideRealIndex);
						if (slideHash) {
							Tools.setPageHash(slideHash);
						}
					}

					$(window).load(() => {
						$mainpageSlider.removeClass('is-loading');
						disablePreloaderInItem($mainpageSliderWrapper);
					});
				});
		}
	});
}
initMainpageSliderController();



// WEBPACK FOOTER //
// ./temp/components/mainpage/index.js